import { Box, Button, Group, LoadingOverlay, Stack } from '@mantine/core';
import TextInput from 'src/components/design-system/input/TextInput';
import { SectionConfig } from '../types';
import SectionList from './SectionList';

type ConfigEditorPanelProps = {
  displayName: string;
  onDisplayNameChange: (name: string) => void;
  sections: SectionConfig[];
  onSectionsChange: (sections: SectionConfig[]) => void;
  onSave: () => void;
  onReset: () => void;
  isSaving: boolean;
  isResetting: boolean;
  isLoading: boolean;
  hasChanges: boolean;
  isDefault: boolean;
};

export default function ConfigEditorPanel({
  displayName,
  onDisplayNameChange,
  sections,
  onSectionsChange,
  onSave,
  onReset,
  isSaving,
  isResetting,
  isLoading,
  hasChanges,
  isDefault,
}: ConfigEditorPanelProps) {
  return (
    <Box pos="relative" style={{ flex: 1 }}>
      <LoadingOverlay visible={isLoading} />
      <Stack gap="md">
        <Group justify="space-between" align="flex-end">
          <Box style={{ flex: 1, maxWidth: 400 }}>
            <TextInput
              label="Configuration name"
              value={displayName}
              onChange={e => onDisplayNameChange(e.currentTarget.value)}
              placeholder="Enter configuration name"
            />
          </Box>
          <Group gap="sm">
            {isDefault && (
              <Button variant="subtle" color="gray" onClick={onReset} loading={isResetting}>
                Reset to defaults
              </Button>
            )}
            <Button onClick={onSave} loading={isSaving} disabled={!hasChanges}>
              Save
            </Button>
          </Group>
        </Group>
        <SectionList sections={sections} onSectionsChange={onSectionsChange} />
      </Stack>
    </Box>
  );
}
